module.exports = __webpack_public_path__ + "img/디스트로이어.af711d6a.png";